import Enum from "../../../enums/Enum";

const SleepingPatternEnum = new Enum({
    LIGHT_SLEEPER: {name: "Light Sleeper", nameInArabic: "نوم قليل"},
    GOOD_SLEEPER: {name: "Good Sleeper", nameInArabic: "نوم جيد"},
    DEEP_SLEEPER: {name: "Deep Sleeper", nameInArabic: "كثيرالنوم"},
});

export default SleepingPatternEnum;